<script context="module">
    import api from '../../api';
    import { writable, derived } from 'svelte/store';

    export const productos = writable([]);
    export const actualizacionesPrecios = writable([]);
    export const ajustesInventario = writable([]);

    export async function traerProductos() {
        const response = await api.get('productos/');
        productos.set(response.data);
    }

    export async function traerAjustesInventario() {
        const response = await api.get('productos/ajustes_inventario/');
        ajustesInventario.set(response.data);
    }

    export async function guardarAjustesInventario(ajustes) {
        const response = await api.post('productos/ajustes_inventario/', {
            ajustes,
        });
        await Promise.all([traerProductos(), traerAjustesInventario()]);
        return response.data;
    }

    export async function cancelarAjusteInventario(id) {
        await api.patch(`productos/ajustes_inventario/${id}/cancelar/`);
        await Promise.all([traerProductos(), traerAjustesInventario()]);
    }

    export const actualizarPrecios = async (archivo, fecha) => {
        const formData = new FormData();
        formData.append('file', archivo);
        formData.append('fecha', fecha);
        await api.post('productos/actualizar_precios/', formData);
        traerProductos();
    };

    export const traerActualizacionesPrecios = async () => {
        const response = await api.get('productos/actualizaciones_precios/');
        actualizacionesPrecios.set(response.data);
    };

    export const cargarActualizacionesPrecios = async (archivo, fecha) => {
        const formData = new FormData();
        formData.append('file', archivo);
        if (fecha) formData.append('fecha', fecha);
        const response = await api.post(
            'productos/actualizaciones_precios/cargar/',
            formData
        );
        await traerActualizacionesPrecios();
        return response.data;
    };

    export const descartarActualizacionesPrecios = async () => {
        const response = await api.post(
            'productos/actualizaciones_precios/descartar_todas/'
        );
        await traerActualizacionesPrecios();
        return response.data;
    };

    export const aplicarActualizacionesAltaConfianza = async fecha => {
        const response = await api.post(
            'productos/actualizaciones_precios/aplicar_alta_confianza/',
            fecha ? { fecha } : {}
        );
        await traerActualizacionesPrecios();
        await traerProductos();
        return response.data;
    };

    export const aplicarActualizacionPrecio = async (id, fecha) => {
        const response = await api.post(
            `productos/actualizaciones_precios/${id}/aplicar/`,
            fecha ? { fecha } : {}
        );
        await traerActualizacionesPrecios();
        await traerProductos();
        return response.data;
    };

    export const rechazarActualizacionPrecio = async id => {
        const response = await api.post(
            `productos/actualizaciones_precios/${id}/rechazar/`
        );
        await traerActualizacionesPrecios();
        return response.data;
    };

    export const actualizarPrecio = async ({ slug, precio }) => {
        await api.put(`productos/${slug}/`, { precio_de_lista: precio });
        traerProductos();
    };
</script>
